<template>
  <UnitQuantity
    :quantity="quantity"
    :estimated-quantity="estimatedQuantity"
    :unit-name="unitName"
    :show-unit="showUnit"
    :pad-length="padLength"
    :show-diff-anim="showDiffAnim"
    :show-change-controls="showChangeControls"
    :open-input="openInput"
    :min-quantity="minQuantity"
    :field-id="fieldId"
    :inline-unit-name="inlineUnitName"
    v-on:update:quantity="($event: any) => $emit('update:quantity', $event)"
  />
</template>

<script setup lang="ts">
import UnitQuantity from "../UnitQuantity.vue";

defineProps({
  quantity: { type: Number, required: true },
  estimatedQuantity: { type: Number, required: false },
  unitName: { type: String, required: true },
  showUnit: { type: Boolean, required: false, default: true },
  padLength: { type: Number, required: false, default: 5, min: 0, max: 5 },
  showDiffAnim: { type: Boolean, required: false, default: false },
  showChangeControls: { type: Boolean, required: false, default: false },
  openInput: { type: Boolean, required: false, default: false },
  minQuantity: { type: Number, required: false, default: 1 },
  fieldId: { type: String, required: false },
  inlineUnitName: { type: Boolean, required: false, default: false }
});

defineEmits(['update:quantity']);
</script>
